<template>
    <div id="pwa-intervention-report" class="mx-2">
        <button-go-back text="Détails intervention"></button-go-back>

        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <div class="intervention-details__card">
                    <p class="font-medium mb-2 text-sm">Étapes</p>
                    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
                    <md-steppers md-vertical md-linear md-dynamic-height :md-active-step.sync="steps.active">

                        <md-step id="situation" md-label="Situation" :md-editable="false" :md-done.sync="steps.situation">
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <div class="md-input-radio">
                                        <label>Présence de nuisibles *</label>
                                        <div>
                                            <md-radio v-model="report.insect.isPresence" class="my-2" :value="true">Oui</md-radio>
                                            <md-radio v-model="report.insect.isPresence" class="my-2" :value="false">Non</md-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template v-if="report.insect.isPresence">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-100">
                                        <div class="md-multiselect">
                                            <label>Nuisible *</label>
                                            <multiselect v-model="report.insect.type"
                                                         :options="config.insects"
                                                         :searchable="false"
                                                         :show-labels="false"
                                                         :max-height="200"
                                                         placeholder="Nuisible"
                                                         label="name"
                                                         track-by="id">
                                                <template slot="noOptions">La liste est vide</template>
                                                <template slot="noResult">Aucun élement correspondant</template>
                                            </multiselect>
                                            <validation-error :errors="apiValidationErrors.insect" />
                                        </div>
                                    </div>
                                </div>
                                <div class="md-layout mt-1">
                                    <div class="md-layout-item md-size-100">
                                        <md-field class="md-invalid">
                                            <label>Autre nuisible {{ report.insect.type && report.insect.type.id === 0 ? '*' : '' }}</label>
                                            <md-input v-model="report.insect.other" type="text" name="insect-other"
                                                      :disabled="report.insect.type === null || report.insect.type.id !== 0" />
                                            <validation-error :errors="apiValidationErrors.insectOther" />
                                        </md-field>
                                    </div>
                                </div>
                                <div class="md-layout mt-3">
                                    <div class="md-layout-item md-size-100">
                                        <div class="md-multiselect">
                                            <label>Degré d'infestation *</label>
                                            <multiselect v-model="report.insect.quantity"
                                                         :options="config.insectsQuantity"
                                                         :searchable="false"
                                                         :show-labels="false"
                                                         :allow-empty="false"
                                                         label="label"
                                                         track-by="id">
                                                <template slot="noOptions">La liste est vide</template>
                                                <template slot="noResult">Aucun élement correspondant</template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="md-layout mt-1">
                                    <div class="md-layout-item md-size-100">
                                        <md-field class="md-invalid">
                                            <label>Localisation *</label>
                                            <md-input v-model="report.insect.location" type="text" name="insect-location" />
                                            <validation-error :errors="apiValidationErrors.location" />
                                        </md-field>
                                    </div>
                                </div>
                            </template>
                            <div class="mt-3.5 my-1 flex items-center">
                                <md-button class="md-success md-icon-button md-raised my-0" @click="validateStep('situation', 'commentsActions')">
                                    <span class="font-medium leading-none">Valider</span>
                                </md-button>
                            </div>
                        </md-step>

                        <md-step id="commentsActions" md-label="Commentaires / Actions" :md-editable="false" :md-done.sync="steps.commentsActions">
                            <div class="md-layout mb-2">
                                <div class="md-layout-item md-size-100">
                                    <div class="md-input-radio">
                                        <label>Autres produits *</label>
                                        <div>
                                            <md-radio v-model="report.products.isActive" class="my-2" :value="true">Oui</md-radio>
                                            <md-radio v-model="report.products.isActive" class="my-2" :value="false">Non</md-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout mb-2">
                                <div class="md-layout-item md-size-100">
                                    <div class="md-multiselect md-multiselect-multiple">
                                        <label>Autres produits utilisés</label>
                                        <multiselect v-model="report.products.items"
                                                     :options="config.products"
                                                     :disabled="!report.products.isActive"
                                                     :multiple="true"
                                                     :searchable="false"
                                                     :close-on-select="false"
                                                     :show-labels="false"
                                                     :max-height="125"
                                                     placeholder="Produits"
                                                     label="name"
                                                     track-by="id">
                                            <template slot="noOptions">La liste est vide</template>
                                            <template slot="noResult">Aucun élement correspondant</template>
                                        </multiselect>
                                        <validation-error :errors="apiValidationErrors.products" />
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <md-field class="md-invalid">
                                        <label>Commentaire libre</label>
                                        <md-textarea v-model="report.comment" name="comment" md-autogrow />
                                    </md-field>
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-3.5 my-1">
                                <md-button class="md-warning md-icon-button md-raised my-0" @click="cancelStep('commentsActions', 'situation')">
                                    <span class="font-medium leading-none">Précédent</span>
                                </md-button>
                                <md-button class="md-success md-icon-button md-raised my-0" @click="validateStep('commentsActions', 'advices')">
                                    <span class="font-medium leading-none">Valider</span>
                                </md-button>
                            </div>
                        </md-step>

                        <md-step id="advices" md-label="Conseils" :md-editable="false" :md-done.sync="steps.advices">
                            <div class="flex items-center justify-between">
                                <div class="md-input-radio md-invalid">
                                    <label>Environnement *</label>
                                    <div>
                                        <md-radio v-model="report.advices.environment" class="my-2 md-danger" :value="1"><span class="text-danger">1</span></md-radio>
                                        <md-radio v-model="report.advices.environment" class="my-2 md-warning" :value="2"><span class="text-warning">2</span></md-radio>
                                        <md-radio v-model="report.advices.environment" class="my-2 md-success" :value="3"><span class="text-success">3</span></md-radio>
                                    </div>
                                    <validation-error :errors="apiValidationErrors.adviceEnvironment" />
                                </div>
                                <div class="text-sm font-medium" :class="`text-${selectedAdvice('environment').color}`">
                                    {{ selectedAdvice('environment').text }}
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-1">
                                <div class="md-input-radio md-invalid">
                                    <label>Déchets *</label>
                                    <div>
                                        <md-radio v-model="report.advices.waste" class="my-2 md-danger" :value="1"><span class="text-danger">1</span></md-radio>
                                        <md-radio v-model="report.advices.waste" class="my-2 md-warning" :value="2"><span class="text-warning">2</span></md-radio>
                                        <md-radio v-model="report.advices.waste" class="my-2 md-success" :value="3"><span class="text-success">3</span></md-radio>
                                    </div>
                                    <validation-error :errors="apiValidationErrors.adviceWaste" />
                                </div>
                                <div class="text-sm font-medium" :class="`text-${selectedAdvice('waste').color}`">
                                    {{ selectedAdvice('waste').text }}
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-1">
                                <div class="md-input-radio md-invalid">
                                    <label>Végétation *</label>
                                    <div>
                                        <md-radio v-model="report.advices.vegetation" class="my-2 md-danger" :value="1"><span class="text-danger">1</span></md-radio>
                                        <md-radio v-model="report.advices.vegetation" class="my-2 md-warning" :value="2"><span class="text-warning">2</span></md-radio>
                                        <md-radio v-model="report.advices.vegetation" class="my-2 md-success" :value="3"><span class="text-success">3</span></md-radio>
                                    </div>
                                    <validation-error :errors="apiValidationErrors.adviceVegetation" />
                                </div>
                                <div class="text-sm font-medium" :class="`text-${selectedAdvice('vegetation').color}`">
                                    {{ selectedAdvice('vegetation').text }}
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-1">
                                <div class="md-input-radio md-invalid">
                                    <label>Étanchéité *</label>
                                    <div>
                                        <md-radio v-model="report.advices.tightness" class="my-2 md-danger" :value="1"><span class="text-danger">1</span></md-radio>
                                        <md-radio v-model="report.advices.tightness" class="my-2 md-warning" :value="2"><span class="text-warning">2</span></md-radio>
                                        <md-radio v-model="report.advices.tightness" class="my-2 md-success" :value="3"><span class="text-success">3</span></md-radio>
                                    </div>
                                    <validation-error :errors="apiValidationErrors.adviceTightness" />
                                </div>
                                <div class="text-sm font-medium" :class="`text-${selectedAdvice('tightness').color}`">
                                    {{ selectedAdvice('tightness').text }}
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-1">
                                <div class="md-input-radio md-invalid">
                                    <label>Sources d'attraction *</label>
                                    <div>
                                        <md-radio v-model="report.advices.attractionSource" class="my-2 md-danger" :value="1"><span class="text-danger">1</span></md-radio>
                                        <md-radio v-model="report.advices.attractionSource" class="my-2 md-warning" :value="2"><span class="text-warning">2</span></md-radio>
                                        <md-radio v-model="report.advices.attractionSource" class="my-2 md-success" :value="3"><span class="text-success">3</span></md-radio>
                                    </div>
                                    <validation-error :errors="apiValidationErrors.adviceAttractionSource" />
                                </div>
                                <div class="text-sm font-medium" :class="`text-${selectedAdvice('attractionSource').color}`">
                                    {{ selectedAdvice('attractionSource').text }}
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-1">
                                <div class="md-input-radio md-invalid">
                                    <label>Accès aux dispositifs *</label>
                                    <div>
                                        <md-radio v-model="report.advices.devicesAccess" class="my-2 md-danger" :value="1"><span class="text-danger">1</span></md-radio>
                                        <md-radio v-model="report.advices.devicesAccess" class="my-2 md-warning" :value="2"><span class="text-warning">2</span></md-radio>
                                        <md-radio v-model="report.advices.devicesAccess" class="my-2 md-success" :value="3"><span class="text-success">3</span></md-radio>
                                    </div>
                                    <validation-error :errors="apiValidationErrors.adviceDevicesAccess" />
                                </div>
                                <div class="text-sm font-medium" :class="`text-${selectedAdvice('devicesAccess').color}`">
                                    {{ selectedAdvice('devicesAccess').text }}
                                </div>
                            </div>
                            <div class="flex items-center justify-between my-1">
                                <md-button class="md-warning md-icon-button md-raised my-0" @click="cancelStep('advices', 'commentsActions')">
                                    <span class="font-medium leading-none">Précédent</span>
                                </md-button>
                                <md-button class="md-success md-icon-button md-raised my-0" @click="validateStep('advices', 'validation')">
                                    <span class="font-medium leading-none">Valider</span>
                                </md-button>
                            </div>
                        </md-step>

                        <md-step id="validation" md-label="Validation" :md-editable="false" :md-done.sync="steps.validation">
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <md-field class="md-invalid">
                                        <label>Temps de travail *</label>
                                        <md-input type="time" v-model="report.workTime" />
                                        <validation-error :errors="apiValidationErrors.workTime" />
                                    </md-field>
                                </div>
                            </div>
                            <div class="flex items-center justify-between mt-3.5 my-1">
                                <md-button class="md-warning md-icon-button md-raised my-0" @click="cancelStep('validation', 'advices')">
                                    <span class="font-medium leading-none">Précédent</span>
                                </md-button>
                                <md-button class="md-success md-icon-button md-raised my-0" @click="validateStep('validation')"
                                           :disabled="steps.validation">
                                    <span class="font-medium leading-none">Valider</span>
                                </md-button>
                            </div>
                        </md-step>

                    </md-steppers>
                </div>
            </div>
        </div>

        <div class="md-layout md-gutter mt-2">
            <div class="md-layout-item md-size-100">

                <div class="intervention-details__card">
                    <p class="font-medium mb-2 text-sm">Rapport</p>
                    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
                    <div class="leading-none mb-1 text-sm">
                        <span>Rédaction du rapport :</span>
                        <span class="ml-1 font-medium" :class="isReportFinished ? 'text-success' : 'text-warning'">
                            {{ isReportFinished ? 'Terminée' : 'En cours' }}
                        </span>
                    </div>
                    <md-divider class="my-2 -mx-2"></md-divider>
                    <div class="mb-1.5 flex items-center justify-end">
                        <md-button class="md-success md-icon-button md-raised my-0" type="submit"
                                   :disabled="!isReportFinished || loading" @click="submitReport">
                            <font-awesome-icon class="md-icon" :icon="['fa', loading ? 'sync-alt' : 'check-circle']" :class="{'animate-spin': loading}" />
                            <span class="leading-none font-medium ml-2">Créer le rapport</span>
                        </md-button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

import { mapState } from "vuex";

import ButtonGoBack from "../components/ButtonGoBack";
export default {
    name: "PwaInterventionReport",
    components: { ButtonGoBack, ValidationError },
    mixins: [formMixin, indexedDBMixin],
    data() {
        return {
            config: {
                insects: [],
                insectsQuantity: [
                    { id: 1, label: 'Faible' },
                    { id: 2, label: 'Modéré' },
                    { id: 3, label: 'Élevé' },
                ],
                products: []
            },
            steps: {
                active: 'situation',
                situation: false,
                commentsActions: false,
                advices: false,
                validation: false,
            },
            report: {
                insect: {
                    isPresence: false,
                    type: null,
                    other: '',
                    quantity: { id: 1, label: 'Faible' },
                    location: '',
                },
                comment: '',
                products: {
                    isActive: false,
                    items: []
                },
                advices: {
                    environment: null,
                    waste: null,
                    vegetation: null,
                    tightness: null,
                    attractionSource: null,
                    devicesAccess: null
                },
                workTime: null
            },
	        loading: false
        }
    },
    computed: mapState({
        user: state => state.pwaAuth.technician,
        isReportFinished() {
            return this.steps.validation && this.steps.commentsActions && this.steps.advices && this.steps.validation
        },
    }),
    methods: {
        async getInsects() {
	        const insects = await this.fetchDataFromIndexedDB(`pwa/insects`)
            this.config.insects.push(...insects.value, { id: 0, name: 'Autre (à saisir)' })
        },
        async getProducts() {
	        const products = await this.fetchDataFromIndexedDB(`pwa/products`)
            this.config.products = products.value
        },
        selectedAdvice(advice) {
            const reportAdvice = this.report.advices[advice]
            if(reportAdvice) {
                return reportAdvice === 1 ? { text: 'Problématique', color: 'danger' } :
                    (reportAdvice === 2 ? { text: 'À améliorer', color: 'warning' } :
                        (reportAdvice === 3 ? { text: 'Satisfaisant', color: 'success' } : ''))
            } else {
                return { text: '', color: 'default' }
            }
        },
        cancelStep(current, previous) {
            this.steps[previous] = false
            this.steps[current] = false
            this.steps.active = previous
        },
        validateStep(currentStep, nextStep) {
            let errors = []
            this.resetApiValidation()

            if(currentStep === 'situation') {
                if(this.report.insect.isPresence) {
                    if(this.report.insect.type === null) {
                        errors.push({
                            source: { pointer: '/data/attributes/insect' },
                            detail: 'Le type de nuisible est obligatoire'
                        })
                    } else if(this.report.insect.type.id === 0 && !this.report.insect.other) {
                        errors.push({
                            source: { pointer: '/data/attributes/insectOther' },
                            detail: 'Le type de nuisible est obligatoire'
                        })
                    }
                    if(!this.report.insect.location) {
                        errors.push({
                            source: { pointer: '/data/attributes/location' },
                            detail: 'La localisation est obligatoire'
                        })
                    }
                }
            } else if(currentStep === 'commentsActions') {
                if(this.report.products.isActive && this.report.products.items.length === 0) {
                    errors.push({
                        source: { pointer: '/data/attributes/products' },
                        detail: 'Au moins un produit doit être sélectionné'
                    })
                }
            } else if(currentStep === 'advices') {
                if(this.report.advices.environment === null) {
                    errors.push({
                        source: { pointer: '/data/attributes/adviceEnvironment' },
                        detail: 'Le poids est obligatoire'
                    })
                }
                if(this.report.advices.waste === null) {
                    errors.push({
                        source: { pointer: '/data/attributes/adviceWaste' },
                        detail: 'Le poids est obligatoire'
                    })
                }
                if(this.report.advices.vegetation === null) {
                    errors.push({
                        source: { pointer: '/data/attributes/adviceVegetation' },
                        detail: 'Le poids est obligatoire'
                    })
                }
                if(this.report.advices.tightness === null) {
                    errors.push({
                        source: { pointer: '/data/attributes/adviceTightness' },
                        detail: 'Le poids est obligatoire'
                    })
                }
                if(this.report.advices.attractionSource === null) {
                    errors.push({
                        source: { pointer: '/data/attributes/adviceAttractionSource' },
                        detail: 'Le poids est obligatoire'
                    })
                }
                if(this.report.advices.devicesAccess === null) {
                    errors.push({
                        source: { pointer: '/data/attributes/adviceDevicesAccess' },
                        detail: 'Le poids est obligatoire'
                    })
                }
            } else if(currentStep === 'validation') {
                if(!this.report.workTime) {
                    errors.push({
                        source: { pointer: '/data/attributes/workTime' },
                        detail: 'Le temps de travail est obligatoire'
                    })
                }
            }

            if(errors.length > 0) {
                this.setApiValidation(errors)
            } else {
                this.steps[currentStep] = true
                if (nextStep) {
                    this.steps.active = nextStep
                }
            }
        },
        async submitReport() {
			this.loading = true

            const { insect, comment, advices, products, workTime } = this.report
            const timeParts = workTime.split(':')
            const duration = (parseInt(timeParts[0]) * 60) + parseInt(timeParts[1])

	        const payload = {
		        access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
		        user_id: this.user.id,
		        model_value: JSON.stringify({
			        isInsects: insect.isPresence ? '1' : '0',
			        insectId: insect.isPresence ? insect.type.id.toString() : 'null',
			        insectOther: insect.isPresence ? insect.other : 'null',
			        insectQuantity: insect.isPresence ? insect.quantity.label : 'null',
			        insectLocation: insect.isPresence ? insect.location : 'null',
			        otherProducts: products.isActive ? '1' : '0',
			        products: products.isActive ? products.items.map(product => product.id.toString()).sort() : 'null',
			        comment: comment,
			        adviceEnvironment: advices.environment.toString(),
			        adviceWaste: advices.waste.toString(),
			        adviceVegetation: advices.vegetation.toString(),
			        adviceTightness: advices.tightness.toString(),
			        adviceAttractionSource: advices.attractionSource.toString(),
			        adviceDevicesAccess: advices.devicesAccess.toString(),
			        duration: duration.toString()
		        })
	        }

            try {
	            const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}`)
	            intervention.value.report = { ...intervention.value.report, model_value: payload }

	            const db = await this.getIndexedDBConnection()
	            const tx = db.transaction('data', 'readwrite')
	            const store = tx.objectStore('data')
	            store.put({ key: `pwa/intervention/${intervention.value.id}`, value: intervention.value })

	            await this.storeRequest(`pwa/planning/${intervention.value.id}/report`, payload)
                await this.$store.dispatch('alerts/success', 'Rapport saisi')
                this.$router.back()
            } catch (e) {
				this.loading = false
            }
        }
    },
    mounted() {
        this.getInsects()
        this.getProducts()
    }
}
</script>

<style scoped>

</style>
